// extracted by mini-css-extract-plugin
export var actionButton = "_iw-t";
export var buttonContainer = "_iw-0";
export var buttonContainer2 = "_iw-1";
export var buttonSection = "_iw-2";
export var details = "_iw-3";
export var dropdownItem = "_iw-5";
export var dropdownItemsContainer = "_iw-4";
export var fileInput = "_iw-r";
export var headerButton = "_iw-6";
export var icon = "_iw-7";
export var input = "_iw-8";
export var macroListItem = "_iw-9";
export var mainContent = "_iw-a";
export var microText = "_iw-b";
export var modal = "_iw-w";
export var optionsButton = "_iw-c";
export var paperclip = "_iw-s";
export var pillContent = "_iw-d";
export var preview = "_iw-e";
export var preview2 = "_iw-f";
export var quillEditor = "_iw-q";
export var selectedMacro = "_iw-g";
export var sidebar = "_iw-h";
export var sidebarHeader = "_iw-j";
export var sidebarList = "_iw-i";
export var sidebarListItem = "_iw-k";
export var sidebarSearch = "_iw-l";
export var snoozeDurationWrapper = "_iw-v";
export var statusPillContainer = "_iw-m";
export var tagsContainer = "_iw-n";
export var unselectedMacro = "_iw-o";
export var variable = "_iw-u";
export var wrapper = "_iw-p";